import script from "./system.vue?vue&type=script&setup=true&lang=js"
export * from "./system.vue?vue&type=script&setup=true&lang=js"

import "./system.vue?vue&type=style&index=0&id=41c19d12&lang=less"

const __exports__ = script;

export default __exports__